import React, { useState, useEffect, createContext, useContext } from 'react';
import PersonalDetails from './grower/personalDetails/personalDetails';
import LandDetails from './grower/landDetailsReg/landDetails';
import { GET_GROWER_BY_URN, UPDATE_GROWER, GET_STAKEHOLDER_BY_URN, ResourceUpdateMember, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../common/URLs'
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';
import JfmcDetails from './grower/personalDetails/jfmcDetails';
import JFMCGovtPersonalDetails from './grower/personalDetails/jfmcGovtPersonalDetails';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { API_DATE_FORMAT, EMPTY_FIELD_ERROR, PROD, RESOURCE_ROLES, ROLES } from '../../../common/constants';
import { toast } from 'react-toastify';
import { getAllComments, insertComment } from './commonRegistrationStakeholderAPIs';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { GetRecentCommentObject } from '../../../common/commonFunction';
import BackButton from '../../../common/backButton';
import { Button, Box, Typography, Grid, Stack, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { emailValidation, urnMaxLength, VALIDATION } from '../../../common/commonValidations';
import Preview from './preview';
import { TextField } from '@mui/material';
import { PreviewIcon, SaveIcon } from '../../../common/icons';
import _ from 'lodash';
import { appInsights } from '../../../AppInsights';
import apiClient from '../../../axios';
import BadgeComponent from '../../../common/badge';
import CommentIcon from '@mui/icons-material/Comment';

const GrowerIndividualContext = createContext();

function RegistrationDetails(props) {
  const { state } = useLocation();
  const urn = state?.URN ? state.URN : props.urn;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [nextPage, setNextPage] = useState(false);
  const [jfmcPage, setJfmcPage] = useState(false);
  const [growerDetails, setGrowerDetails] = useState();
  const [newLandArray, setNewLandArray] = useState([]);
  const [commentsData, setCommentsData] = useState();
  const [comments, setComments] = useState([]);
  const decoded = jwt(getLocalStorageItem('id_token'));
  let userRole = localStorage.getItem('role');
  let uuid = localStorage.getItem('uuid');
  const [expandedSection, setExpandedSection] = useState("personal");
  const bambooSpeciesRes = props.bambooSpeciesRes;

  const [errorMessage, setErrorMessage] = useState({
    contactPersonFirstNameError: '',
    emailIdError: '',
    accountNumberError: '',
    accountHolderNameError: '',
    govtIdCardNumberError: '',
    ifscCodeError: '',
    addressError: '',
    OTPError: '',
    documentError: '',
    panDocError: '',
    idProofDocError: '',
    agreementStartDateError: '',
    agreementEndDateError: '',
    bankDocError: '',
    addressError: '',
    pincodeError: '',
    stateError: '',
    districtError: '',
    subDivisionError: '',
    blockNameError: '',
    captiveError: '',
    captiveStartDateError: '',
    captiveEndDateError: '',
    landAreaError: '',
    availablelandAreaError: '',
    landLeasedOwnedError: '',
    leaseStartDateError: '',
    leaseEndDateError: '',
    landTypeError: '',
    easeOfSourcingError: '',
    sidingRequirementError: '',
    sidingDistanceInMtrsError: '',
    growerBambooSpeciesError: '',
    regGrowerMasterIdError: '',
    landNameError: '',
    longitudesError: '',
    latitudesError: '',
    aggregationPincodeError: '',
    aggregationNameError: '',
    aggregationLongitudesError: '',
    aggregationLatitudesError: '',
    aggregationrevenueCircleError: '',
    documentError: '',
    landDetailsError: '',
    landDocumentError: '',
    landPicsError: '',
    divisionalForestOfficeNameErr: "",
    divisionalForestOfficeAddressErr: "",
    divisionalForestOfficeContactNameErr: "",
    divisionalForestOfficeContactNoErr: "",
    forestRangeOfficeNameErr: "",
    forestRangeOfficeAddressErr: "",
    forestRangeOfficeContactNameErr: "",
    forestRangeOfficeContactNoErr: "",
    forestRangeBeatNameErr: "",
    forestRangeBeatAddressErr: "",
    forestRangeBeatContactNameErr: "",
    forestRangeBeatContactNoErr: "",
    personalCommentError: "",
    bankCommentError: "",
    agreementCommentError: "",
    jfmcForestCommentError: "",
    landCommentError: ""
  });

  const [currentPage, setCurrentPage] = useState("registrationDetails");
  const [buttonAction, setButtonAction] = useState("");
  const [callUpdateApi, setCallUpdateApi] = useState(false);
  const [newLandComments, setNewLandComments] = useState([]);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
  const [stakeHolderDetails, setStakeHolderDetails] = useState();
  const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
  const [showClarificationButton, setShowClarificationButton] = useState(false);
  const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
  const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
  const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
  // const [bambooDetailsSectionOk, setBambooDetailsSectionOk] = useState(false);
  const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
  const [jfmcDetailsSectionOk, setJfmcDetailsSectionOk] = useState(false);
  const [shouldActOnSection, setShouldActOnSection] = useState({
    personal_details: false,
    bank_details: false,
    agreement_details: false,
    // bamboo_details: false,
    jfmc_details: false
  })
  const [landDetailsSectionOk, setLandDetailsSectionOk] = useState({});
  const [shouldActOnSectionLand, setShouldActOnSectionLand] = useState({});
  const [callWorkFlowApi, setCallWorkFlowApi] = useState(false)
  const [personalUpdatedDetails, setPersonalUpdatedDetails] = useState();
  const [landUpdatedDetails, setLandUpdatedDetails] = useState();
  // const [jfmcUpdatedDetails, setJfmcUpdatedDetails] = useState();
  const [jfmcUpdatedDetails, setJfmcUpdatedDetails] = useState();

  const enableFieldFunction = (sectionEnabled, isPreg, isNew, isLatLon) => {
    if (state?.viewOnly) return false;

    if (userRole === ROLES.ItAdmin) return true;

    if (
      userRole === ROLES.RegistrationScruitnizer &&
      state?.userType === "Internal"
    ) return true;

    if (
      growerDetails?.growers?.[0]?.growerType === "JFMC" &&
      isLatLon &&
      userRole === ROLES.RegistrationScruitnizer &&
      stakeHolderDetails?.currentOwnerID === uuid
    ) return true;

    if (isNew) return true;

    if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
      if (
        stakeHolderDetails?.scrutinyStatus !== "Pending_Clarification" &&
        !isLatLon &&
        stakeHolderDetails?.registrationCompleted &&
        stakeHolderDetails?.scrutinyStatus !== "Approved"
      ) {
        return false;
      }
      return true;
    }

    return false;
  };

  const getStakeholderDetailsFromUrn = () => {
    loaderService.showLoader();
    apiClient.post(GET_STAKEHOLDER_BY_URN,
      {
        "urn": urn,
        "includeRejected": true,
        "isScrutinyView": true
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        loaderService.hideLoader();
        let stakeHolderDetailsLocal = response.data.stakeHolder;
        setStakeHolderDetails(response.data.stakeHolder);
        if (stakeHolderDetailsLocal) {
          const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid
          if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
            &&
            (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)
          ) {
            setShowCommentSection(true);
          }
          if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
            setShowCommentSection(true);
            setRegScruResourceUpdate(true);
          }
          if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected" && (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated"))) || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated") || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved"))) {
            setEnableSaveSubmitButtons(true);
          }
          if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
            // && state?.registerByScruOtpValidated for otp validation in pending clarification add after userole in below line
            if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus == "Pending_Clarification") {
              setShowClarificationButton(true);
              setEnableSaveSubmitButtons(true);
            }
            if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus != "Pending_Clarification")) {
              setShowWorkFlowButtons(true);
            }
          }
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });

  }

  useEffect(() => {
    const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
    setComments(commentsData);
    newLandArray?.map((item) => {
      return (
        landDetailsSectionOk[`${item.id}`] = GetRecentCommentObject(commentsData?.filter((filterItem) => filterItem.sectionName === "land_details" && filterItem.sectionId === item.id))?.sectionOk ? GetRecentCommentObject(commentsData?.filter((filterItem) => filterItem.sectionName === "land_details" && filterItem.sectionId === item.id))?.sectionOk : false,
        shouldActOnSectionLand[`${item.id}`] = false
      )
    })
    let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
    let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
    // let bambooCommentsInitial = commentsData?.filter((item) => item.sectionName === "bamboo_details");
    let agreementDetailsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
    let jfmcDetailsInitial = commentsData?.filter((item) => item.sectionName === "jfmc_details");
    setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
    setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
    // setBambooDetailsSectionOk(GetRecentCommentObject(bambooCommentsInitial)?.sectionOk ? GetRecentCommentObject(bambooCommentsInitial)?.sectionOk : false);
    setAgreementDetailsSectionOk(GetRecentCommentObject(agreementDetailsInitial)?.sectionOk ? GetRecentCommentObject(agreementDetailsInitial)?.sectionOk : false);
    setJfmcDetailsSectionOk(GetRecentCommentObject(jfmcDetailsInitial)?.sectionOk ? GetRecentCommentObject(jfmcDetailsInitial)?.sectionOk : false);
    if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = false;
      });
    }
    else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = true;
      });
    }
    else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
      Object.keys(shouldActOnSection).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
        shouldActOnSection[key] = !section?.sectionOk;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionId === key && obj.isActive === 1);
        shouldActOnSectionLand[key] = !section?.sectionOk;
      });
    }
    else {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = true;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = true;
      });
    }
  }, [commentsData]);

  useEffect(() => {
    if (urn) {
      getgrowerDetails();
      getStakeholderDetailsFromUrn();
    }
  }, [urn]);

  useEffect(() => {
    if (callUpdateApi) {
      appInsights.trackEvent({
        name: 'Details Changed',
        properties: {
          timeStamp: new Date().toISOString(),
          user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
        }
      })
      if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
        onCheckUserDistrictMapping();
      }
      else updateGrower();
    }
  }, [callUpdateApi]);

  const onCheckUserDistrictMapping = () => {
    loaderService.showLoader();
    apiClient.post(CHECK_USER_DISTRICT_MAPPING,
      {
        "state": stakeHolderDetails?.growerMasters?.[0]?.state,
        "plotDistrict": stakeHolderDetails?.growerMasters?.[0]?.plotDistrict
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          updateGrower();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  function getgrowerDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_GROWER_BY_URN,
        {
          "urn": urn,
          "type": "grower",
          "isScrutinyView": "true"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        let growerDetailsLocal = response.data
        setGrowerDetails(response.data);
        if (growerDetailsLocal) {
          setNewLandArray(growerDetailsLocal?.growers[0]?.growerLandDetails ? growerDetailsLocal?.growers[0]?.growerLandDetails : []);
          newLandComments.map((item) => {
            const { type, id, landName, createdByName, createdOnFormatted, workflowStepDetailsId, ...commentObject } = item
            const findItem = growerDetailsLocal.growers[0].growerLandDetails.find((findItem) => findItem.landName === item.landName)
            if (findItem) {
              item.sectionId = findItem.id
            }
            return commentObject
          })
          newLandComments.length > 0 ? insertComment(newLandComments, growerDetailsLocal?.growers[0]?.regStakeholderMasterId, setCommentsData) : getAllComments(growerDetailsLocal?.growers[0]?.regStakeholderMasterId, setCommentsData)
          setNewLandComments([])
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }
  const getRegistrationStatus = () => {
    const grower = growerDetails?.growers[0];
    const regStakeholderMaster = grower?.regStakeholderMaster;
    var regStatus = regStakeholderMaster?.registrationStatus;
    if (userRole !== ROLES.ItAdmin) {
      if (regStakeholderMaster?.registrationStatus === "Approved" && userRole === RESOURCE_ROLES.PlantSCMMember || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal")) {
        regStatus = "ResourceUpdate_Initiated";
      }
    }
    return regStatus;
  }
  const getResourceUpdateFlag = () => {
    var isApprovedStakeholder = stakeHolderDetails?.isApprovedStakeholder;
    if (userRole !== ROLES.ItAdmin && isApprovedStakeholder) {
      return true;
    }
    return false;
  }
  const getSubmit = () => {
    if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
      return true
    }
    else {
      return false
    }
  }

  const noCommentForMandatorySections = () => {
    if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
      if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if ((growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency') && comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if (growerDetails?.growers[0]?.growerType === 'JFMC' && comments.find((item) => item.sectionName === "jfmc_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "jfmc_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("jfmcForest");
        setErrorMessage({ ...errorMessage, jfmcForestCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
    }
    else {
      if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if ((growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency') && shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
      if (growerDetails?.growers[0]?.growerType === 'JFMC' && shouldActOnSection.jfmc_details && !comments.find((item) => item.sectionName === "jfmc_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("jfmcForest");
        setErrorMessage({ ...errorMessage, jfmcForestCommentError: "Please enter comment and save" });
        // toast.error( "Please enter comment and save")
        return true;
      }
    }
    return false
  }

  const personalDetailsValidation = () => {
    if (personalUpdatedDetails.growerType !== "Individual") {
      if (!personalUpdatedDetails.emailId || personalUpdatedDetails.emailId.length == 0) {
        setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" });
        toast.error("Please enter Email Address");
        setExpandedSection("personal");
        return;
      }
      else if (personalUpdatedDetails.emailId.length > 0 && !emailValidation(personalUpdatedDetails.emailId.slice(0, 50))) {
        setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" });
        toast.error("Please enter valid Email Address");
        setExpandedSection("personal");
        return;
      }
    }

    if (!personalUpdatedDetails.address || personalUpdatedDetails.address.length == 0) {
      setErrorMessage({ addressError: "Please enter address" });
      toast.error("Please enter address")
      setExpandedSection("personal");
      return;
    }
    if (personalUpdatedDetails.pincode && personalUpdatedDetails.pincode.length !== 6) {
      setErrorMessage({ pincodeError: "Please enter a valid pincode" });
      toast.error("Please enter a valid pincode")
      setExpandedSection("personal");
      return;
    }
    if (!personalUpdatedDetails.state || personalUpdatedDetails.state.length == 0) {
      setErrorMessage({ searchError: "Please search pincode" });
      toast.error("Please search pincode")
      setExpandedSection("personal");
      return;
    }
    if (!(ResourceUpdateMember.includes(userRole) && userRole === 'Reg-ITAdmin')) {
      if (!personalUpdatedDetails.govtIdCardNumber || personalUpdatedDetails.govtIdCardNumber.length == 0) {
        setErrorMessage({ govtIdCardNumberError: "Please enter ID Number" });
        toast.error("Please enter ID Number")
        setExpandedSection("personal");
        return;
      }
      else if (personalUpdatedDetails.panNumber && personalUpdatedDetails.panNumber.length > 0 && !VALIDATION.panNumberValidation(personalUpdatedDetails.panNumber)) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
        toast.error("Please enter valid PAN Number")
        setExpandedSection("personal");
        return;
      }
    }
    var idProof = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === ((growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency') ? "MOA_RegistrationCertificate" : "IDProof") && (item.isActive == 1 || item.isActive == 3));
    if (idProof.length == 0) {
      setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
      toast.error("Please upload ID Proof document")
      setExpandedSection("personal");
      return;
    }
    bankDetailsValidations();
  }

  const bankDetailsValidations = () => {
    if (!(ResourceUpdateMember.includes(userRole) && userRole === 'Reg-ITAdmin')) {
      if (!personalUpdatedDetails.bankAccountNumber || personalUpdatedDetails.bankAccountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(personalUpdatedDetails.bankAccountNumber)) {
        setErrorMessage({ accountNumberError: "Please enter valid Account Number" });
        toast.error("Please enter valid Account Number");
        setExpandedSection("bank");
        return;
      }
      else if (!personalUpdatedDetails.bankAccountHolderName || personalUpdatedDetails.bankAccountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(personalUpdatedDetails.bankAccountHolderName)) {
        setErrorMessage({ accountHolderNameError: "Please enter Account Holder's Name" });
        toast.error("Please enter Account Holder's Name");
        setExpandedSection("bank");
        return;
      }
      else if (!personalUpdatedDetails.bankIfscCode || personalUpdatedDetails.bankIfscCode.length == 0 || !VALIDATION.ifscValidation(personalUpdatedDetails.bankIfscCode)) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC code" });
        toast.error("Please enter valid IFSC code");
        setExpandedSection("bank");
        return;
      }
      else if (!personalUpdatedDetails.bankBranch || personalUpdatedDetails.bankBranch.length == 0) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" });
        toast.error("Please enter valid IFSC code and search");
        setExpandedSection("bank");
        return;
      }
      //var panCard = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "PANCard" && item.isActive == 1);
      //if (panCard.length == 0) {
      //    setErrorMessage({ panDocError: "Please upload PAN documents" });
      //    return;
      //}

      var bankdoc = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "BankPassBook_CancelledCheque" && (item.isActive == 1 || item.isActive == 3));
      if (bankdoc.length == 0) {
        setErrorMessage({ bankDocError: "Please upload bank document" });
        toast.error("Please upload bank document");
        setExpandedSection("bank");
        return;
      }
    }
    (growerDetails?.growers[0]?.growerType === 'JFMC') ? agreementDetailsValidations() : showPreview();
  }

  const agreementDetailsValidations = () => {
    if (!personalUpdatedDetails.agreementStartDate || personalUpdatedDetails.agreementStartDate.length == 0) {
      setErrorMessage({ ...errorMessage, bankDocError: '', agreementStartDateError: "Please enter agreement start date" })
      toast.error("Please enter agreement start date");
      setExpandedSection("agreement");
      return;
    }
    else if (!personalUpdatedDetails.agreementEndDate || personalUpdatedDetails.agreementEndDate.length == 0) {
      setErrorMessage({ ...errorMessage, agreementStartDateError: '', agreementEndDateError: "Please enter agreement end date" })
      toast.error("Please enter agreement end date");
      setExpandedSection("agreement");
      return;
    }
    else if (personalUpdatedDetails.agreementStartDate >= personalUpdatedDetails.agreementEndDate) {
      setErrorMessage({ ...errorMessage, agreementEndDateError: "agreement end date can not be less than agreement start date" })
      toast.error("agreement end date can not be less than agreement start date");
      setExpandedSection("agreement");
      return;
    }
    var agreement = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "LOI_ABRPLAgreement" && (item.isActive == 1 || item.isActive == 3));
    if (agreement.length == 0) {
      setErrorMessage({ ...errorMessage, agreementEndDateError: '', agreementDocError: "Please upload LOI and agreement document" });
      toast.error("Please upload LOI and agreement document");
      setExpandedSection("agreement");
      return;
    }
    var harvest = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "Harvest_Plan" && (item.isActive == 1 || item.isActive == 3));
    if (harvest.length == 0) {
      setErrorMessage({ ...errorMessage, agreementDocError: '', harvestPlanDocError: "Please upload harvesting plan document" });
      toast.error("Please upload harvesting plan document");
      setExpandedSection("agreement");
      return;
    }
    growerDetails?.growers[0]?.growerType === 'JFMC' ? jfmcForestValidations() : showPreview();
  }

  const jfmcForestValidations = () => {
    if (!jfmcUpdatedDetails.divisionalForestOfficeName || jfmcUpdatedDetails.divisionalForestOfficeName.length == 0) {
      setErrorMessage({ ...errorMessage, divisionalForestOfficeNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.divisionalForestOfficeAddress || jfmcUpdatedDetails.divisionalForestOfficeAddress.length == 0) {
      setErrorMessage({ ...errorMessage, divisionalForestOfficeAddressErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.divisionalForestOfficeContactName || jfmcUpdatedDetails.divisionalForestOfficeContactName.length == 0) {
      setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.divisionalForestOfficeContactNo || jfmcUpdatedDetails.divisionalForestOfficeContactNo.length == 0) {
      setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNoErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeOfficeName || jfmcUpdatedDetails.forestRangeOfficeName.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeOfficeNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeOfficeAddress || jfmcUpdatedDetails.forestRangeOfficeAddress.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeOfficeAddressErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeOfficeContactName || jfmcUpdatedDetails.forestRangeOfficeContactName.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeOfficeContactNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeOfficeContactNo || jfmcUpdatedDetails.forestRangeOfficeContactNo.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeOfficeContactNoErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeBeatName || jfmcUpdatedDetails.forestRangeBeatName.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeBeatNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeBeatAddress || jfmcUpdatedDetails.forestRangeBeatAddress.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeBeatAddressErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeBeatContactName || jfmcUpdatedDetails.forestRangeBeatContactName.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeBeatContactNameErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else if (!jfmcUpdatedDetails.forestRangeBeatContactNo || jfmcUpdatedDetails.forestRangeBeatContactNo.length == 0) {
      setErrorMessage({ ...errorMessage, forestRangeBeatContactNoErr: EMPTY_FIELD_ERROR });
      toast.error(EMPTY_FIELD_ERROR);
      setExpandedSection("jfmcForest");
      return;
    }
    else showPreview();
  }

  const showPreview = () => {
    const filteredLandComments = comments.filter((item) => item.sectionName === "land_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)
    let mandatoryFeildsCommentNotEntered = false;
    let latLonNotEntered = false;
    newLandArray.forEach(land => {
      const landId = land.id;
      const isMandatory = shouldActOnSectionLand[landId];
      const latLonMandate = localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid
      let landPic = land?.growerLandDocuments && land?.growerLandDocuments.filter((item) => item.documentType === "LandPics" && (item.isActive === 1 || item.isActive === 3))

      if (growerDetails?.growers[0]?.growerType === 'JFMC' && latLonMandate && (!land?.geocodeLattitude || !land?.geocodeLongitude || landPic?.length === 0)) {
        latLonNotEntered = true;
        return;
      }
      else if (showCommentSection) {
        if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
          if (comments.find((item) => item.sectionId === landId && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !filteredLandComments.some(comment => comment.sectionId === landId)) {
            mandatoryFeildsCommentNotEntered = true
            setExpandedSection("land");
            setErrorMessage({ ...errorMessage, landCommentError: "Please add comment for land" });
            // toast.error("Please add comment for land");
          }
        }
        else {
          if (isMandatory && !filteredLandComments.some(comment => comment.sectionId === landId)) {
            mandatoryFeildsCommentNotEntered = true
            setExpandedSection("land");
            setErrorMessage({ ...errorMessage, landCommentError: "Please add comment for required lands" });
            // toast.error("Please add comment for required lands");
          }
        }
      }
    });
    if (newLandArray?.length === 0) {
      setErrorMessage({ ...errorMessage, landDetailsError: "Please add atleast one land" });
      toast.error("Please add atleast one land");
      setExpandedSection("land");
      return;
    }
    if (latLonNotEntered) {
      setExpandedSection("land");
      setErrorMessage({ ...errorMessage, landCommentError: "Please enter latitude and longitude and upload land pic for all lands" });
      toast.error("Please enter latitude and longitude and upload land pic for all lands");
      return;
    }
    else if (showCommentSection && (noCommentForMandatorySections() || mandatoryFeildsCommentNotEntered)) {
      toast.error("Please enter comments for required sections");
      return;
    }
    else {
      setErrorMessage({ ...errorMessage, landDetailsError: "" });
      enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
      setButtonAction("preview")
    }
  }
  const grower = growerDetails?.growers[0];
  const regStakeholderMaster = grower?.regStakeholderMaster;
  const initialData = {
    "id": regStakeholderMaster?.id,
    "name": regStakeholderMaster?.name,
    "contactPersonName": regStakeholderMaster?.contactPersonName,
    "contactPersonFirstname": regStakeholderMaster?.contactPersonFirstname,
    "contactPersonMiddlename": regStakeholderMaster?.contactPersonMiddlename,
    "contactPersonLastname": regStakeholderMaster?.contactPersonLastname,
    "contactPersonGender": regStakeholderMaster?.contactPersonGender,
    "contactPersonSalutation": regStakeholderMaster?.contactPersonSalutation,
    "mobileNo": regStakeholderMaster?.mobileNo,
    "isOtpValidated": regStakeholderMaster?.isOtpValidated,
    "bankAccountNumber": regStakeholderMaster?.bankAccountNumber,
    "bankAccountHolderName": regStakeholderMaster?.bankAccountHolderName,
    "bankBranch": regStakeholderMaster?.bankBranch,
    "bankIfscCode": regStakeholderMaster?.bankIfscCode,
    "bankName": regStakeholderMaster?.bankName,
    "panNumber": regStakeholderMaster?.panNumber,
    "govtIdCardType": regStakeholderMaster?.govtIdCardType,
    "govtIdCardNumber": regStakeholderMaster?.govtIdCardNumber,
    "otherGovtCardType": regStakeholderMaster?.otherGovtCardType,
    "emailId": regStakeholderMaster?.emailId,
    "category": regStakeholderMaster?.category,
    "stakeHolderType": regStakeholderMaster?.stakeHolderType,
    "urn": regStakeholderMaster?.urn,
    "preRegistrationShortlisted": regStakeholderMaster?.preRegistrationShortlisted,
    "registrationStatus": regStakeholderMaster?.registrationStatus,
    "scrutinyStatus": regStakeholderMaster?.scrutinyStatus,
    "stakeholderStatus": regStakeholderMaster?.stakeholderStatus,
    "createdOn": regStakeholderMaster?.createdOn,
    "createdBy": regStakeholderMaster?.createdBy,
    "updatedOn": regStakeholderMaster?.updatedOn,
    "updatedBy": regStakeholderMaster?.updatedBy,
    "isActive": regStakeholderMaster?.isActive,
    "acceptedTerms": regStakeholderMaster?.acceptedTerms,
    "emailId": regStakeholderMaster?.emailId,
    "isResourceUpdate": getResourceUpdateFlag(),
    "isMSME": growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency' ? regStakeholderMaster?.isMSME : null,
    "msmeCategory": growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency' ? regStakeholderMaster?.msmeCategory : null,
    "growerDetails": [
      {
        "id": grower?.id,
        "regStakeholderMasterId": grower?.regStakeholderMasterId,
        "growerCategory": grower?.growerCategory,
        "growerType": grower?.growerType,
        "authorizedContactPerson": grower?.authorizedContactPerson,
        "address": grower?.address,
        "pincode": grower?.pincode,
        "state": grower?.state,
        "district": grower?.district,
        "revenueCircle": grower?.revenueCircle,
        "blockName": grower?.blockName,
        "expansionPlan": grower?.expansionPlan,
        "aggregationPoint": grower?.aggregationPoint,
        "aggregationPointName": grower?.aggregationPointName,
        "aggregationPointContact": grower?.aggregationPointContact,
        "aggregationPointPincode": grower?.aggregationPointPincode,
        "aggregationPointAddress": grower?.aggregationPointAddress,
        "aggregationPointState": grower?.aggregationPointState,
        "aggregationPointDistrict": grower?.aggregationPointDistrict,
        "aggregationPointSubDivision": grower?.aggregationPointSubDivision,
        "aggregationPointPostOffice": grower?.aggregationPointPostOffice,
        "readyToHarvest": grower?.readyToHarvest,
        "locationGeocode": grower?.locationGeocode,
        "documentId": grower?.documentId,
        "forestDeptPincode": grower?.forestDeptPincode,
        "forestDeptState": grower?.forestDeptState,
        "forestDeptDistrict": grower?.forestDeptDistrict,
        "forestDeptSubDivision": grower?.forestDeptSubDivision,
        "forestDeptPostOffice": grower?.forestDeptPostOffice,
        "forestDeptTotalLandArea": grower?.forestDeptTotalLandArea,
        "forestDeptTotalNoOfBambooClumps": grower?.forestDeptTotalNoOfBambooClumps,
        "divisionalForestOfficeName": grower?.divisionalForestOfficeName,
        "divisionalForestOfficeAddress": grower?.divisionalForestOfficeAddress,
        "divisionalForestOfficeContactName": grower?.divisionalForestOfficeContactName,
        "divisionalForestOfficeContactNo": grower?.divisionalForestOfficeContactNo,
        "forestRangeOfficeName": grower?.forestRangeOfficeName,
        "forestRangeOfficeAddress": grower?.forestRangeOfficeAddress,
        "forestRangeOfficeContactName": grower?.forestRangeOfficeContactName,
        "forestRangeOfficeContactNo": grower?.forestRangeOfficeContactNo,
        "forestRangeBeatName": grower?.forestRangeBeatName,
        "forestRangeBeatAddress": grower?.forestRangeBeatAddress,
        "forestRangeBeatContactName": grower?.forestRangeBeatContactName,
        "forestRangeBeatContactNo": grower?.forestRangeBeatContactNo,
        "agreementStartDate": grower?.agreementStartDate,
        "agreementEndDate": grower?.agreementEndDate,
        "plotAddress": grower?.plotAddress,
        "plotPincode": grower?.plotPincode,
        "plotState": grower?.plotState,
        "plotDistrict": grower?.plotDistrict,
        "plotSubDivision": grower?.plotSubDivision,
        "plotRevenueCircle": grower?.plotRevenueCircle,
        "plotBlockName": grower?.plotBlockName,
        "plotPostOffice": grower?.plotPostOffice,
        "plotTotalLandArea": grower?.plotTotalLandArea,
        "plotTotalNoOfBambooClumps": grower?.plotTotalNoOfBambooClumps,
        "cooperativeName": grower?.cooperativeName,
        "cooperativeContact": grower?.cooperativeContact,
        "royaltyCharge": grower?.royaltyCharge,
        "anyOtherFee": grower?.anyOtherFee,
        "createdOn": grower?.createdOn,
        "createdBy": grower?.createdBy,
        "updatedOn": grower?.updatedOn,
        "updatedBy": grower?.updatedBy,
        "isActive": grower?.isActive,
        "growerForestRangeDetails": grower?.growerForestRangeDetails,
        "growerLandDetails": grower?.growerLandDetails,
        "growerDocuments": grower?.growerDocuments,
      }
    ]
  }

  const isMSMENo =
    personalUpdatedDetails?.isMSME === 0 ||
    personalUpdatedDetails?.isMSME === "NO";


  // const filteredGrowerDocuments = isMSMENo
  //   ? personalUpdatedDetails?.growerDocuments?.filter(
  //     (doc) => doc.documentType !== "MSME_Certificate"
  //   )
  //   : personalUpdatedDetails?.growerDocuments;

  const filteredGrowerDocuments = personalUpdatedDetails?.growerDocuments?.map(doc => {
    if (doc.documentType === "MSME_Certificate") {
      return {
        ...doc,
        isActive: isMSMENo ? 0 : 1
      };
    }
    return doc;
  });

  const uniqueLandNames = Array.from(new Set(newLandArray.map(obj => obj.landName)));
  const finalData = {
    "id": regStakeholderMaster?.id,
    "name": personalUpdatedDetails?.fullName,
    "contactPersonName": personalUpdatedDetails?.contactPersonName,
    "contactPersonFirstname": personalUpdatedDetails?.contactPersonFirstname,
    "contactPersonMiddlename": personalUpdatedDetails?.contactPersonMiddlename,
    "contactPersonLastname": personalUpdatedDetails?.contactPersonLastname,
    "contactPersonGender": personalUpdatedDetails?.contactPersonGender,
    "contactPersonSalutation": personalUpdatedDetails?.contactPersonSalutation,
    "mobileNo": personalUpdatedDetails?.mobileNo,
    "isOtpValidated": personalUpdatedDetails?.isOtpValidated,
    "bankAccountNumber": personalUpdatedDetails?.bankAccountNumber,
    "bankAccountHolderName": personalUpdatedDetails?.bankAccountHolderName,
    "bankBranch": personalUpdatedDetails?.bankBranch,
    "bankIfscCode": personalUpdatedDetails?.bankIfscCode,
    "bankName": personalUpdatedDetails?.bankName,
    "panNumber": personalUpdatedDetails?.panNumber,
    "govtIdCardType": personalUpdatedDetails?.govtIdCardType,
    "govtIdCardNumber": personalUpdatedDetails?.govtIdCardNumber,
    "otherGovtCardType": personalUpdatedDetails?.otherGovtCardType,
    "emailId": regStakeholderMaster?.emailId,
    "category": regStakeholderMaster?.category,
    "stakeHolderType": regStakeholderMaster?.stakeHolderType,
    "urn": regStakeholderMaster?.urn,
    "preRegistrationShortlisted": regStakeholderMaster?.preRegistrationShortlisted,
    "registrationStatus": getRegistrationStatus(),
    "scrutinyStatus": regStakeholderMaster?.scrutinyStatus,
    "stakeholderStatus": regStakeholderMaster?.stakeholderStatus,
    "createdOn": regStakeholderMaster?.createdOn,
    "createdBy": regStakeholderMaster?.createdBy,
    "updatedOn": regStakeholderMaster?.updatedOn,
    "updatedBy": regStakeholderMaster?.updatedBy,
    "isActive": regStakeholderMaster?.isActive,
    "acceptedTerms": regStakeholderMaster?.acceptedTerms,
    "emailId": personalUpdatedDetails?.emailId,
    "isResourceUpdate": getResourceUpdateFlag(),
    "isMSME": growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency' ? personalUpdatedDetails?.isMSME : null,
    "msmeCategory": growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency' ? personalUpdatedDetails?.msmeCategory : null,
    "growerDetails": [
      {
        "id": grower?.id,
        "regStakeholderMasterId": grower?.regStakeholderMasterId,
        "growerCategory": grower?.growerCategory,
        "growerType": grower?.growerType,
        "authorizedContactPerson": grower?.authorizedContactPerson,
        "address": personalUpdatedDetails?.address,
        "pincode": personalUpdatedDetails?.pincode,
        "state": personalUpdatedDetails?.state,
        "district": personalUpdatedDetails?.district,
        "revenueCircle": personalUpdatedDetails?.revenueCircle,
        "blockName": personalUpdatedDetails?.blockName,
        "expansionPlan": grower?.expansionPlan,
        "aggregationPoint": personalUpdatedDetails?.aggregationPoint,
        "aggregationPointName": personalUpdatedDetails?.aggregationPointName,
        "aggregationPointContact": personalUpdatedDetails?.aggregationPointContact,
        "aggregationPointPincode": personalUpdatedDetails?.aggregationPointPincode,
        "aggregationPointAddress": personalUpdatedDetails?.aggregationPointAddress,
        "aggregationPointState": personalUpdatedDetails?.aggregationPointState,
        "aggregationPointDistrict": personalUpdatedDetails?.aggregationPointDistrict,
        "aggregationPointSubDivision": personalUpdatedDetails?.aggregationPointSubDivision,
        "aggregationPointPostOffice": personalUpdatedDetails?.aggregationPointPostOffice,
        "readyToHarvest": grower?.readyToHarvest,
        "locationGeocode": grower?.locationGeocode,
        "documentId": grower?.documentId,
        "forestDeptPincode": grower?.forestDeptPincode,
        "forestDeptState": grower?.forestDeptState,
        "forestDeptDistrict": grower?.forestDeptDistrict,
        "forestDeptSubDivision": grower?.forestDeptSubDivision,
        "forestDeptPostOffice": grower?.forestDeptPostOffice,
        "forestDeptTotalLandArea": grower?.forestDeptTotalLandArea,
        "forestDeptTotalNoOfBambooClumps": grower?.forestDeptTotalNoOfBambooClumps,
        "divisionalForestOfficeName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.divisionalForestOfficeName : grower?.divisionalForestOfficeName,
        "divisionalForestOfficeAddress": jfmcUpdatedDetails ? jfmcUpdatedDetails?.divisionalForestOfficeAddress : grower?.divisionalForestOfficeAddress,
        "divisionalForestOfficeContactName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.divisionalForestOfficeContactName : grower?.divisionalForestOfficeContactName,
        "divisionalForestOfficeContactNo": jfmcUpdatedDetails ? jfmcUpdatedDetails?.divisionalForestOfficeContactNo : grower?.divisionalForestOfficeContactNo,
        "forestRangeOfficeName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeOfficeName : grower?.forestRangeOfficeName,
        "forestRangeOfficeAddress": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeOfficeAddress : grower?.forestRangeOfficeAddress,
        "forestRangeOfficeContactName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeOfficeContactName : grower?.forestRangeOfficeContactName,
        "forestRangeOfficeContactNo": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeOfficeContactNo : grower?.forestRangeOfficeContactNo,
        "forestRangeBeatName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeBeatName : grower?.forestRangeBeatName,
        "forestRangeBeatAddress": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeBeatAddress : grower?.forestRangeBeatAddress,
        "forestRangeBeatContactName": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeBeatContactName : grower?.forestRangeBeatContactName,
        "forestRangeBeatContactNo": jfmcUpdatedDetails ? jfmcUpdatedDetails?.forestRangeBeatContactNo : grower?.forestRangeBeatContactNo,
        "agreementStartDate": personalUpdatedDetails?.agreementStartDate,
        "agreementEndDate": personalUpdatedDetails?.agreementEndDate,
        "plotAddress": personalUpdatedDetails?.plotAddress,
        "plotPincode": personalUpdatedDetails?.plotPincode,
        "plotState": personalUpdatedDetails?.plotState,
        "plotDistrict": personalUpdatedDetails?.plotDistrict,
        "plotSubDivision": personalUpdatedDetails?.plotSubDivision,
        "plotRevenueCircle": personalUpdatedDetails?.plotRevenueCircle,
        "plotBlockName": personalUpdatedDetails?.plotBlockName,
        "plotPostOffice": personalUpdatedDetails?.plotPostOffice,
        "plotTotalLandArea": personalUpdatedDetails?.plotTotalLandArea,
        "plotTotalNoOfBambooClumps": personalUpdatedDetails?.plotTotalNoOfBambooClumps,
        "cooperativeName": grower?.cooperativeName,
        "cooperativeContact": grower?.cooperativeContact,
        "royaltyCharge": grower?.royaltyCharge,
        "anyOtherFee": grower?.anyOtherFee,
        "createdOn": grower?.createdOn,
        "createdBy": grower?.createdBy,
        "updatedOn": grower?.updatedOn,
        "updatedBy": grower?.updatedBy,
        "isActive": grower?.isActive,
        "growerForestRangeDetails": grower?.growerForestRangeDetails,
        "growerLandDetails": uniqueLandNames.map(name => {
          return newLandArray.find(obj => obj.landName === name);
        }),
        "growerDocuments": growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency' ? filteredGrowerDocuments : personalUpdatedDetails?.growerDocuments,
      }
    ]
  }

  function updateGrower() {
    loaderService.showLoader();
    apiClient
      .post(UPDATE_GROWER + `?IsRegistrationSubmit=${getSubmit()}`,
        finalData,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        loaderService.hideLoader();
        const updateGrowerResponse = response?.data
        setCallUpdateApi(false);
        if (updateGrowerResponse?.isSuccess) {
          getgrowerDetails();
          if (buttonAction === "preview") {
            setCurrentPage("preview")
          }
          if (buttonAction === "submit" || buttonAction === "save") {
            toast.success(updateGrowerResponse?.message);
          }
          if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
            onSubmit();
          }
          if (buttonAction === "submit") {
            if (decoded.extension_URN) {
              navigate('/dashboardHome/dashboardStakeHolder');
            }
            else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
              navigate('/resourcedashboard/searchByURN');
            }
            else if (userRole === ROLES.ItAdmin) {
              navigate('/sidebar/viewAllActiveApplications');
            }
            else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
              navigate('/registrationHome/registrationScrutiny');
            }
            else if (userRole === ROLES.RegistrationScruitnizer) {
              setCallWorkFlowApi(true);
            }
            else {
              navigate(-1);
            }
          }
        }
        else {
          toast.error(updateGrowerResponse?.message);
          setCurrentPage("registrationDetails")
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  const onGoBack = () => {
    setCurrentPage("registrationDetails")
  }

  const onSubmit = () => {
    loaderService.showLoader();
    apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
      {
        "stakeholderMappings": [
          {
            "scrutinizerId": getLocalStorageItem('uuid'),
            "stakeholderID": stakeHolderDetails?.id,
            "stakeholderState": stakeHolderDetails?.growerMasters?.[0]?.state,
            "stakeholderDistrict": stakeHolderDetails?.growerMasters?.[0]?.district,
            "loggedInUserID": getLocalStorageItem('uuid'),
            "isActive": 1,
            // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
          }
        ]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          onActionWorflowSubmit();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const onActionWorflowSubmit = () => {
    loaderService.showLoader();
    apiClient.post(ALLOCATE_WORKFLOW,
      {
        "stakeHolderMasterID": stakeHolderDetails?.id,
        "workflowInitiatorID": getLocalStorageItem('uuid'),
        "workflowReceiverID": "",
        "workflowAction": "Approve",
        "status": "",
        "isStakeHolderAction": false,
        "workflowInitiatorRole": localStorage.getItem('role'),
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data?.message);
          if (getLocalStorageItem('uuid'))
            navigate('/registrationHome/dashboard');
          else
            navigate('/dashboardHome/dashboardStakeHolder');
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  return (
    <GrowerIndividualContext.Provider value={{ growerDetails, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, jfmcDetailsSectionOk, setJfmcDetailsSectionOk, shouldActOnSection, setShouldActOnSection, landDetailsSectionOk, setLandDetailsSectionOk, shouldActOnSectionLand, setShouldActOnSectionLand, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated: state?.registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, personalUpdatedDetails, setPersonalUpdatedDetails, landUpdatedDetails, setLandUpdatedDetails, errorMessage, setErrorMessage, expandedSection, setExpandedSection, regScruResourceUpdate, setRegScruResourceUpdate, setCallUpdateApi, newLandComments, setNewLandComments, setCallUpdateApi, newLandArray, setNewLandArray, callWorkFlowApi, jfmcUpdatedDetails, setJfmcUpdatedDetails, viewOnly: state?.viewOnly, userType: state?.userType }}>
      <>
        {currentPage === "registrationDetails" && <Container maxWidth="xxl" >
          {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG17</p>}
          <Stack direction="row" alignItems="center" spacing={1} mb={3}>
            <BackButton navigate={navigate} />
            <Typography variant="h5" gutterBottom>
              {t('reg.registrationDetails')}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <TextField fullWidth
                required
                disabled
                type="text"
                label="URN"
                value={urn || ''}
              />
              <BadgeComponent currentLength={urn?.length} maxLength={urnMaxLength} />
            </Grid>
            {(growerDetails?.growers[0]?.growerType === 'Individual' || growerDetails?.growers[0]?.growerType === 'Grower') && <PersonalDetails urn={urn} />}
            {(growerDetails?.growers[0]?.growerType === 'JFMC' || growerDetails?.growers[0]?.growerType === 'Other Agency') && <JFMCGovtPersonalDetails urn={urn} />}
            {growerDetails?.growers[0]?.growerType === 'JFMC' && <JfmcDetails urn={urn}></JfmcDetails>}
            {<LandDetails urn={urn} bambooSpeciesRes={bambooSpeciesRes} />}
          </Grid>
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            {(!showWorkFlowButtons || (growerDetails?.growers[0]?.growerType === 'JFMC' && localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid)) &&
              <Button
                sx={{ minWidth: 100 }}
                variant="contained"
                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                onClick={() => { (!_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                startIcon={<SaveIcon />}
              >{t('preReg.save')}
              </Button>
            }
            <Button
              sx={{ minWidth: 100, ml: 1 }}
              variant="contained"
              onClick={() => personalDetailsValidation()}
              startIcon={<PreviewIcon />}
            >{t('preReg.preview')}</Button>
          </Box>
        </Container>}
        {currentPage === "preview" &&
          <Grid xs={12} md={12} id='divPreview'>
            <Preview urn={urn} goBack={onGoBack} bambooSpeciesRes={bambooSpeciesRes} callWorkFlowApi={callWorkFlowApi} stakeholderType="Grower" subCategory="Individual" />
          </Grid>}
      </>
    </GrowerIndividualContext.Provider>
  );
}
export default RegistrationDetails;
export const useGrowerIndividulalContextData = () => useContext(GrowerIndividualContext)